import { Box } from "@mui/material";

import Tag from "../../common/Tag";

import { selectOffers } from "../../../../features/productAnalyzer/productAnalyzer.selector";
import { useAppSelector } from "../../../../store/hooks";
import { useMemo } from "react";

export const OffersSummary = () => {
  const { offers } = useAppSelector(selectOffers);

  const hasAmazonOffer = useMemo(
    () =>
      offers.some((offer) => offer.sellerName.toLowerCase() === "amazon.com"),
    [offers],
  );

  const fbaCount = useMemo(
    () => offers.filter((offer) => offer.fulfillment === "FBA").length,
    [offers],
  );

  const fbmCount = useMemo(
    () => offers.filter((offer) => offer.fulfillment === "FBM").length,
    [offers],
  );

  return (
    <Box
      display="flex"
      alignItems="start"
      gap="4px"
      width="100%"
      position="relative"
    >
      <Tag
        tooltip="Total live offer count available for delivery to your delivery address or geographical location"
        title={`Offers: ${offers.length}`}
        variant="success"
      />

      {hasAmazonOffer && (
        <Tag tooltip="Amazon is on the listing" title="AMZ" variant="default" />
      )}

      {!!fbaCount && (
        <Tag
          tooltip="Total number of FBA offers"
          title={`FBA: ${fbaCount}`}
          variant="default"
        />
      )}

      {!!fbmCount && (
        <Tag
          tooltip="Total number of FBM offers"
          title={`FBM: ${fbmCount}`}
          variant="default"
        />
      )}
    </Box>
  );
};

export default OffersSummary;
